<template>
  <div class="elr-input-group">
    <label :for="fieldName">{{required ? '* ' : ''}}{{label}}:</label>
    <textarea
      :id="fieldName"
      cols="30"
      rows="10"
      :value="value"
      :placeholder="placeholder ? placeholder : label"
      :name="fieldName"
      :class="{ 'has-error': hasError }"
      :aria-required="required"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    ></textarea>
    <small class="elr-input-support" v-if="supportText">{{supportText}}</small>
    <small class="error-message" v-if="hasError">
      {{errorMessage}}
    </small>
  </div>
</template>

<script>
export default {
  name: 'InputTextArea',
  props: {
    errors: {
      type: Object
    },
    label: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    errorMessage: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    required: {
      type: Boolean
    },
    supportText: {
      type: String
    },
    placeholder: {
      type: String
    }
  },
  computed: {
    hasError() {
      return this.inErrors(this.errors, this.fieldName);
    }
  },
  methods: {
    hasErrors(errors) {
      if (errors) {
        return !!Object.keys(errors).length;
      }

      return false;
    },
    inErrors(errors, field) {
      if (!this.hasErrors(errors)) {
        return;
      }

      const keys = Object.keys(errors);

      return keys.includes(field)
    }
  }
}
</script>

<style lang="scss" scoped>

@import '../../assets/sass/config';

textarea {
  border: 1px solid #999;
  font-size: 14px;
}

.has-error {
  border-color: $red;
}

.error-message {
  color: $red;
}

[disabled] {
  border-color: #ddd;
  background-color: #eee;
}
</style>
